import React, { useState } from "react";
import { Menu } from "lucide-react";
import Sidebar from "../../component/Sidebar";

function PartnerLayout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <style>{`

        /* =================================
           PARTNER MAIN LAYOUT
        ================================= */

        .partner-layout {
          display: flex;
          width: 100%;
          min-height: 100vh;

          background: #f8fafc;

          overflow-x: hidden;
        }


        /* =================================
           MOBILE TOP BAR (hamburger)
        ================================= */

        .partner-mobile-topbar {
          display: none;
        }


        /* =================================
           PARTNER SIDEBAR
        ================================= */

        .partner-sidebar-wrapper {
          width: 250px;
          min-width: 250px;

          height: 100vh;

          position: fixed;

          top: 0;
          left: 0;

          z-index: 1000;
        }


        /* =================================
           MAIN CONTENT
        ================================= */

        .partner-content {
          width: calc(100% - 250px);

          min-height: 100vh;

          margin-left: 250px;

          box-sizing: border-box;

          background: #f8fafc;

          overflow-x: hidden;
        }


        /* =================================
           CONTENT INNER
        ================================= */

        .partner-content-inner {
          width: 100%;

          max-width: 1600px;

          margin: 0 auto;
        }


        /* =================================
           TABLET
        ================================= */

        @media (max-width: 992px) {

          .partner-sidebar-wrapper {
            width: 220px;
            min-width: 220px;
          }

          .partner-content {
            width: calc(100% - 220px);

            margin-left: 220px;

            padding: 20px;
          }

        }


        /* =================================
           MOBILE
           Sidebar becomes a fixed slide-in
           drawer (handled inside Sidebar.jsx
           via the mobile-open class), so the
           content column no longer needs to
           reserve any left margin/width for it.
        ================================= */

        @media (max-width: 768px) {

          .partner-layout {
            display: block;
          }

          .partner-mobile-topbar {
            display: flex;
            align-items: center;
            gap: 10px;

            padding: 12px 16px;

            background: #ffffff;
            border-bottom: 1px solid #e9e5ed;

            position: sticky;
            top: 0;
            z-index: 900;
          }

          .partner-mobile-topbar button {
            background: none;
            border: none;
            padding: 4px;
            color: #3E0F8D;
            cursor: pointer;
            display: flex;
            align-items: center;
          }

          .partner-mobile-topbar span {
            font-weight: 800;
            color: #3E0F8D;
            font-size: 15px;
          }

          .partner-sidebar-wrapper {
            width: auto;
            min-width: 0;
            height: auto;
            position: static;
          }

          .partner-content {
            width: 100%;

            margin-left: 0;

            padding: 15px;
          }

        }

      `}</style>


      <div className="partner-layout">

        {/* ===============================
            MOBILE TOP BAR
        =============================== */}

        <div className="partner-mobile-topbar">
          <button
            type="button"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={22} />
          </button>
          <span>CertED</span>
        </div>


        {/* ===============================
            PARTNER SIDEBAR
        =============================== */}

        <div className="partner-sidebar-wrapper">

          <Sidebar
            isMobileOpen={mobileOpen}
            onClose={() => setMobileOpen(false)}
          />

        </div>


        {/* ===============================
            MAIN CONTENT
        =============================== */}

        <main className="partner-content">

          <div className="partner-content-inner">

            {children}

          </div>

        </main>

      </div>
    </>
  );
}

export default PartnerLayout;